import { useState, useEffect } from "react";

/* ═══════════════════════════════════════════════════════════
   PROMO TEMPORAIRE — Lagon by Al Camar Lodge, −15% du 12 au 25 octobre

   Affichage seulement. L'hôtel a déjà baissé ses prix lui-même : ce
   fichier ne touche à aucun calcul, il affiche l'ancien prix barré et un
   badge. À supprimer après la promo (ce fichier + les lignes marquées
   "PROMO TEMP" dans HotelList, HotelPage et Checkout).
   ═══════════════════════════════════════════════════════════ */

const PROMO = {
  hotelId: "6ab6e888883be4eef92e0e1f",
  slug: "lagon-by-al-camar-lodge",
  pourcentage: 15,
  debut: "2026-10-12",
  fin: "2026-10-25",
};

const jourComores = (d) =>
  new Date(d).toLocaleDateString("en-CA", { timeZone: "Indian/Comoro" });

// Date de référence : celle passée, sinon l'arrivée dans l'URL, sinon aujourd'hui
function dateReference(date) {
  if (date) return date;
  const checkIn = new URLSearchParams(window.location.search).get("checkIn");
  return checkIn || new Date();
}

// Vrai si l'hôtel correspond (par id, par slug, ou parce qu'on est sur sa page)
// et que la date tombe dans la période.
export function promoActive({ hotelId, slug, date } = {}) {
  const surSaPage = window.location.pathname.includes(`/hotel/slug/${PROMO.slug}`);
  const memeHotel = (hotelId && String(hotelId) === PROMO.hotelId) || (slug && slug === PROMO.slug) || surSaPage;
  if (!memeHotel) return false;
  const jour = jourComores(dateReference(date));
  return jour >= PROMO.debut && jour <= PROMO.fin;
}

export const pourcentagePromo = PROMO.pourcentage;

export function prixAvantPromo(prix) {
  return Math.round(Number(prix) / (1 - PROMO.pourcentage / 100));
}

// Le montant principal d'un tarif renvoyé par l'API (même règle que formatPlanPrice)
export function montantPlan(p) {
  if (!p) return null;
  return p.stayType && p.stayType !== "short_stay" ? p.total : p.pricePerNight;
}

export function BadgePromo({ style }) {
  return (
    <span style={{ background: "#FFB32E", color: "#1D1D1B", fontSize: 13, fontWeight: 800, padding: "3px 9px", borderRadius: 6, whiteSpace: "nowrap", lineHeight: 1.3, ...style }}>
      −{PROMO.pourcentage}%
    </span>
  );
}

// Ancien prix barré + badge, à poser juste au-dessus ou à côté du prix actuel
export function AvantPromo({ prix, style }) {
  if (prix == null || isNaN(Number(prix))) return null;
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 6, ...style }}>
      <span style={{ fontSize: 15, fontWeight: 600, color: "#6b7280", textDecoration: "line-through", textDecorationColor: "#ef4444", textDecorationThickness: 2 }}>{prixAvantPromo(prix)}€</span>
      <BadgePromo />
    </span>
  );
}

const fmtJour = (iso) => new Date(iso + "T12:00:00").toLocaleDateString("fr-FR", { day: "numeric", month: "long" });

// Bandeau bien visible : sidebar de la page hôtel, liste des suites, checkout
export function BandeauPromo({ style, texte = "Offre exclusive sur komorotel.com" }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 12, background: "#FFF4DC", border: "1.5px solid #FFB32E", borderRadius: 12, padding: "10px 14px", ...style }}>
      <span style={{ background: "#FFB32E", color: "#1D1D1B", fontSize: 18, fontWeight: 800, padding: "6px 10px", borderRadius: 8, whiteSpace: "nowrap", lineHeight: 1 }}>
        −{PROMO.pourcentage}%
      </span>
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: "#1D1D1B", lineHeight: 1.3 }}>{texte}</div>
        <div style={{ fontSize: 12, color: "#6b4e16", marginTop: 2 }}>Du {fmtJour(PROMO.debut)} au {fmtJour(PROMO.fin)}</div>
      </div>
    </div>
  );
}

// Bannière cliquable en haut de la page de résultats (HotelList)
export function BanniereResultats({ hotel, queryString = "" }) {
  if (!hotel) return null;
  return (
    <a href={`/hotel/slug/${hotel.slug}${queryString}`} className="promo-banniere"
      style={{ display: "flex", alignItems: "stretch", textDecoration: "none", color: "inherit", background: "#174D3A", borderRadius: 16, overflow: "hidden", marginBottom: 24, boxShadow: "0 6px 24px rgba(23,77,58,0.18)" }}>
      {hotel.photos?.[0] && (
        <div className="promo-banniere-photo" style={{ width: 240, flexShrink: 0, position: "relative" }}>
          <img src={hotel.photos[0]} alt={hotel.name} style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
        </div>
      )}
      <div style={{ flex: 1, minWidth: 0, padding: "20px 24px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16, flexWrap: "wrap" }}>
        <div style={{ minWidth: 0 }}>
          <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.12em", color: "#FFB32E", marginBottom: 6 }}>OFFRE EXCLUSIVE KOMOROTEL.COM</div>
          <div style={{ fontFamily: "Georgia, serif", fontSize: 22, fontWeight: 700, color: "#fff", lineHeight: 1.25 }}>
            −{PROMO.pourcentage}% au {hotel.name}
          </div>
          <div style={{ fontSize: 13, color: "rgba(255,255,255,0.8)", marginTop: 6 }}>
            Sur les suites, du {fmtJour(PROMO.debut)} au {fmtJour(PROMO.fin)}
          </div>
        </div>
        <span style={{ background: "#FFB32E", color: "#1D1D1B", fontSize: 13, fontWeight: 800, padding: "11px 18px", borderRadius: 10, whiteSpace: "nowrap" }}>
          Voir l'offre →
        </span>
      </div>
      <style>{`@media (max-width: 640px) { .promo-banniere { flex-direction: column; } .promo-banniere-photo { width: 100% !important; height: 140px; } }`}</style>
    </a>
  );
}

// Charge l'hôtel en promo (par son slug) tant que la promo est en cours
export function useHotelPromo() {
  const [hotel, setHotel] = useState(null);
  useEffect(() => {
    if (!promoActive({ slug: PROMO.slug, date: new Date() })) return;
    fetch(`https://api.komorotel.com/api/hotels/slug/${PROMO.slug}`)
      .then(r => r.json())
      .then(d => { if (d && d._id) setHotel(d); })
      .catch(() => {});
  }, []);
  return hotel;
}

// Section "Offre du moment" pour la page d'accueil, juste sous le hero
export function OffreDuMoment({ hotel }) {
  if (!hotel) return null;
  const prix = hotel.minPrice;
  return (
    <section style={{ background: "#fff", padding: "56px 16px 8px" }}>
      <a href={`/hotel/slug/${hotel.slug}`} className="offre-moment"
        style={{ maxWidth: 1248, margin: "0 auto", display: "grid", gridTemplateColumns: "1.1fr 1fr", borderRadius: 20, overflow: "hidden", textDecoration: "none", color: "inherit", background: "#174D3A", boxShadow: "0 12px 40px rgba(23,77,58,0.22)" }}>
        <div className="offre-moment-photo" style={{ position: "relative", minHeight: 340 }}>
          {hotel.photos?.[0] && <img src={hotel.photos[0]} alt={hotel.name} style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }} />}
          <span style={{ position: "absolute", top: 18, left: 18, background: "#FFB32E", color: "#1D1D1B", fontSize: 12, fontWeight: 800, letterSpacing: "0.08em", padding: "6px 12px", borderRadius: 8 }}>
            OFFRE DU MOMENT
          </span>
        </div>
        <div style={{ padding: "40px 44px", display: "flex", flexDirection: "column", justifyContent: "center", color: "#fff" }}>
          <div style={{ fontFamily: "Georgia, serif", fontSize: 84, fontWeight: 800, lineHeight: 0.95, color: "#FFB32E", letterSpacing: "-0.02em" }}>
            −{PROMO.pourcentage}%
          </div>
          <div style={{ fontSize: 15, color: "rgba(255,255,255,0.8)", marginTop: 14 }}>sur les suites du</div>
          <div style={{ fontFamily: "Georgia, serif", fontSize: 30, fontWeight: 700, lineHeight: 1.15, marginTop: 4 }}>{hotel.name}</div>
          <div style={{ fontSize: 14, color: "rgba(255,255,255,0.8)", marginTop: 10 }}>
            {[hotel.city, hotel.island].filter(Boolean).join(", ")}
          </div>
          <div style={{ display: "inline-flex", alignSelf: "flex-start", marginTop: 18, border: "1.5px solid #FFB32E", borderRadius: 10, padding: "8px 14px", fontSize: 15, fontWeight: 700 }}>
            Du {fmtJour(PROMO.debut)} au {fmtJour(PROMO.fin)}
          </div>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16, marginTop: 26, flexWrap: "wrap" }}>
            {prix ? (
              <div>
                <span style={{ fontSize: 15, color: "rgba(255,255,255,0.6)", textDecoration: "line-through", marginRight: 8 }}>{prixAvantPromo(prix)}€</span>
                <span style={{ fontSize: 26, fontWeight: 800 }}>{prix}€</span>
                <span style={{ fontSize: 13, color: "rgba(255,255,255,0.7)" }}> /nuit</span>
              </div>
            ) : <span />}
            <span style={{ background: "#FFB32E", color: "#1D1D1B", fontSize: 14, fontWeight: 800, padding: "13px 22px", borderRadius: 12, whiteSpace: "nowrap" }}>
              Voir l'offre →
            </span>
          </div>
          <div style={{ fontSize: 12, color: "rgba(255,255,255,0.6)", marginTop: 14 }}>Exclusivement sur komorotel.com</div>
        </div>
        <style>{`@media (max-width: 860px) {
          .offre-moment { grid-template-columns: 1fr !important; }
          .offre-moment-photo { min-height: 220px !important; }
          .offre-moment > div:last-of-type { padding: 28px 22px !important; }
        }`}</style>
      </a>
    </section>
  );
}